import { Component, Input, OnInit } from '@angular/core';
import IAttributesStatisticFlags = ZoningAPI.IAttributesStatisticFlags;

@Component({
    standalone: false,
    selector: 'ziq-calibration-set-attributes-icons',
    templateUrl: './calibration-set-attributes-icons.component.html',
    styleUrls: ['./calibration-set-attributes-icons.component.scss']
})
export class CalibrationSetAttributesIconsComponent implements OnInit {
    @Input()
    attributesFlags: IAttributesStatisticFlags;

    constructor() {}

    ngOnInit() {}
}
